import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { saveAs } from 'file-saver/FileSaver';
import { UserService } from '../../../../services/user.service';
import { ReportService } from '../../../../services/report.service';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-other-government',
  templateUrl: './other-government.component.html',
  styleUrls: ['./other-government.component.css']
})
export class CommonReportsOtherGovernmentComponent implements OnInit, OnDestroy {
  othcommonreportform: FormGroup;
  allSub: Subscription[] = [];
  errorMessage: string = '';
  downloadMessage: string = '';
  loading: boolean = false;
  userName: string = '';
  screenCode: string = '';
  isSubmit: boolean = false;
  airlineAgencyCodes = [];
  accountOfficeCodes = [];
  sortedBy = [
    { value: 'Acc_Acc_No', viewValue: 'Pukal Number' },
    { value: 'Acc_Acc_Off_Code', viewValue: 'Account Office Code' },
    { value: 'Bill_Agency_Code', viewValue: 'Agency Code' },
    { value: 'Acc_Airline_Agency_Code', viewValue: 'Airline Agency Code' },
    { value: 'Bill_Agency_Code', viewValue: 'Travel Agent' },
    { value: 'Bill_Booking_Dt', viewValue: 'Booking Date' },
    { value: 'Bill_Pnr', viewValue: 'PNR' },
    { value: 'Bill_Pymnt_Dt', viewValue: 'Payment Date' },
    { value: 'Bill_Pymnt_Type', viewValue: 'Payment Type' }
  ];
  orderBy = [
    { value: 'ASC', viewValue: 'Ascending' },
    { value: 'DESC', viewValue: 'Descending' }
  ];
  fileType = [
    { value: '.pdf', viewValue: 'PDF File' },
    { value: '.xls', viewValue: 'Excel File' }
  ];
  typeOfInvoices = [
    { value: '1', viewValue: 'Generated' },
    { value: '0', viewValue: 'Non-Generated' }
  ];

  constructor(private userService: UserService,
    private reportService: ReportService,
    public snackBar: MatSnackBar) {
    let user = this.userService.getUser();
    this.userName = user.username;
    this.screenCode = user.screenCode;
  }

  ngOnInit() {
    this.othcommonreportform = new FormGroup({
      airlineAgencyCode: new FormControl({ value: '', disabled: false }),
      accountOfficeCode: new FormControl({ value: '', disabled: false }),
      pukalNumber: new FormControl({ value: '', disabled: false }, [Validators.maxLength(32767)]),
      travelagent: new FormControl({ value: '', disabled: false }, [Validators.maxLength(32767)]),
      agencyCode: new FormControl({ value: '', disabled: false }, [Validators.maxLength(32767)]),
      pnr: new FormControl({ value: '', disabled: false }, [Validators.maxLength(32767)]),
      paymentType: new FormControl({ value: '', disabled: false }, [Validators.maxLength(32767)]),
      bookingDateFrom: new FormControl({ value: new Date, disabled: false }, [Validators.required]),
      bookingDateTo: new FormControl({ value: new Date, disabled: false }, [Validators.required]),
      paymentDateFrom: new FormControl({ value: new Date, disabled: false }, [Validators.required]),
      paymentDateTo: new FormControl({ value: new Date, disabled: false }, [Validators.required]),
      commonReportSortBy: new FormControl({ value: new Date, disabled: false }),
      commonReportOrderBy: new FormControl({ value: new Date, disabled: false }),
      exportedFileType: new FormControl({ value: new Date, disabled: false }),
      typeOfInvoice: new FormControl({ value: new Date, disabled: false })
    });

    this.loading = true;

    let initial_sub = this.reportService.getInitOthCommonReports()
      .subscribe(
        (data) => {
          this.loading = false;
          if (data.status === 204) {

          } else if (data.status === 200) {
            this.airlineAgencyCodes = data.body['agentCodes'];
            this.accountOfficeCodes = data.body['accountOffices'];

            this.othcommonreportform.setValue({
              airlineAgencyCode: this.airlineAgencyCodes[0].Airline_Agency_Code,
              accountOfficeCode: this.othcommonreportform.get('accountOfficeCode')!.value,
              pukalNumber: this.othcommonreportform.get('pukalNumber')!.value,
              travelagent: this.othcommonreportform.get('travelagent')!.value,
              agencyCode: this.othcommonreportform.get('agencyCode')!.value,
              pnr: this.othcommonreportform.get('pnr')!.value,
              paymentType: this.othcommonreportform.get('paymentType')!.value,
              bookingDateFrom: this.othcommonreportform.get('bookingDateFrom')!.value,
              bookingDateTo: this.othcommonreportform.get('bookingDateTo')!.value,
              paymentDateFrom: this.othcommonreportform.get('paymentDateFrom')!.value,
              paymentDateTo: this.othcommonreportform.get('paymentDateTo')!.value,
              commonReportSortBy: this.sortedBy[0].value,
              commonReportOrderBy: this.orderBy[0].value,
              exportedFileType: this.fileType[0].value,
              typeOfInvoice: this.othcommonreportform.get('typeOfInvoice')!.value
            });
          } else {
            this.openSnackBar('Error loading agency and account office.', '');
          }
        },
        (error) => {
          this.loading = false;
          this.errorMessage = <any>error;
          this.openSnackBar(this.errorMessage, '');
        });

    //Adds into array for each subscribe
    this.allSub.push(initial_sub);
  }

  onSubmit(form: FormGroup) {
    this.isSubmit = true;
    this.downloadMessage = 'System is generating report....';

    let DownloadCommonReport = {
      PukalNumber: this.othcommonreportform.get('pukalNumber')!.value,
      AccountOfficeCode: this.othcommonreportform.get('accountOfficeCode')!.value,
      TravelAgent: this.othcommonreportform.get('travelagent')!.value,
      AgencyCode: this.othcommonreportform.get('agencyCode')!.value,
      AirlineAgencyCode: this.othcommonreportform.get('airlineAgencyCode')!.value,
      Pnr: this.othcommonreportform.get('pnr')!.value,
      PaymentType: this.othcommonreportform.get('paymentType')!.value,
      BookingDateFrom: this.othcommonreportform.get('bookingDateFrom')!.value,
      BookingDateTo: this.othcommonreportform.get('bookingDateTo')!.value,
      PaymentDateFrom: this.othcommonreportform.get('paymentDateFrom')!.value,
      PaymentDateTo: this.othcommonreportform.get('paymentDateTo')!.value,
      SortBy: this.othcommonreportform.get('commonReportSortBy')!.value,
      OrderBy: this.othcommonreportform.get('commonReportOrderBy')!.value,
      FileType: this.othcommonreportform.get('exportedFileType')!.value,
      InvoiceType: this.othcommonreportform.get('typeOfInvoice')!.value
    }

    let save_sub = this.reportService.downloadOthCommonReports(DownloadCommonReport)
      .subscribe(
        (value) => {
          if (value.status === 204) {
            this.isSubmit = false;
            this.openSnackBar('Download failed.', '');
          } else if (value.status === 200) {
            if (DownloadCommonReport.FileType === '.xls') {
              let blob = new Blob([value.body], { type: 'application/vnd.ms-excel' });
              saveAs(blob, 'OTH CommonReport.xls');
              this.openSnackBar('Report Created.', '');
              this.isSubmit = false;
            } else if (DownloadCommonReport.FileType === '.pdf') {
              let blob = new Blob([value.body], { type: 'application/pdf' });
              saveAs(blob, 'OTH CommonReport.pdf');
              this.openSnackBar('Report Created.', '');
              this.isSubmit = false;
            }
          } else {
            this.isSubmit = false;
            this.openSnackBar('Download failed.', '');
          }
        },
        (error) => {
          this.errorMessage = <any>error;
          this.isSubmit = false;
          this.openSnackBar(this.errorMessage, '');
        });

    //Adds into array for each subscribe
    this.allSub.push(save_sub);
  }

  ngOnDestroy() {
    for (let sub of this.allSub) {
      sub.unsubscribe();
    }
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
    });
  }
}
